import { Component, OnDestroy, Pipe, PipeTransform, HostListener, ViewChild } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {MatDialog, MatDialogRef} from '@angular/material';

import {ApiService} from '../shared/api.service';
import {AssignmentsService} from '../shared/assignments.service';
import {ImagesService} from '../shared/images.service';
import {StatusMap} from '../assignments/assignment.model';
import {SlideshowService} from './slideshow.service';
import {routerTransition} from '../router.animations';

@Pipe({name: 'sites'})
export class SitesPipe implements PipeTransform {
    transform(list, primary): string {
        if( !list ) return;
        return list.filter(item => item.permalink != '' && primary ? item.primary : !item.primary);
    }
}
@Component({
    selector: 'slideshow-component',
    templateUrl: 'slideshow.component.html',
    animations: [ routerTransition ],
})
export class SlideshowComponent implements OnDestroy {
    user;
    statuses;
    trayOpen = false;
    uploadSubscription;
    showAdditionalMenu = false;
    showPublishReadyBtn = false;
    deleteSubscription;

    @ViewChild('actions') actions;
    @ViewChild('group') tabGroup;

    @HostListener('window:beforeunload', ['$event']) 
    noGo (e) {
        if( this.slideshow.locked || this.slideshow.objEq(this.slideshow.getBackup(this.slideshow), this.slideshow.backup) ) {
            return true;
        }
        e.preventDefault();
        e.returnValue = undefined;
        return undefined;
    }

    constructor(
        private api: ApiService, 
        private assignments: AssignmentsService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private router: Router,
        public slideshow: SlideshowService,
        public imagesService: ImagesService
        ) {
        this.user = this.api.getProp('user');
        if( this.user.role == 'editor' || this.user.role == 'administrator' ) {
            this.showAdditionalMenu = true;
        }
        this.route.params.subscribe(params => {
            if( params.hasOwnProperty('id') ) {
                this.slideshow.loadSlideshow(params.id);
            }
        });
        this.statuses = StatusMap;
        this.uploadSubscription = this.imagesService.uploadComplete.subscribe(images => {
            this.trayOpen = false;
        });
        this.deleteSubscription = this.assignments.deleted.subscribe(data => {
            this.reset();
            this.router.navigate(['/assignments', 'queue']);
        });
        if( !this.slideshow.assignment ) {
            const assignmentSubscription = this.slideshow.assignmentLoaded.subscribe(assignment => {
                this.initButtons();
                assignmentSubscription.unsubscribe();
            });
        } else {
            this.initButtons();
        }
        this.slideshow.statusChange.subscribe(() => {
            this.initButtons();
        });
    }
    ngAfterViewInit() {
        if( !this.slideshow.locked && this.actions ) {
            this.actions.nativeElement.querySelector('.noevents').classList.remove('noevents');
        }
    }
    initButtons() {
        const status = this.slideshow.assignment.status;
        if( ['publish_ready', 'publish', 'imported'].indexOf(status) === -1 ) {
            this.showPublishReadyBtn = true;
        } else {
            this.showPublishReadyBtn = false;
        }
    }
    hasPublishedSites() {
        const sites = this.slideshow.assignment.sites;
        const len = sites.length;
        if( len <= 1 ) {
            return false;
        }
        for(var i = 0; i < len; i++) {
            const site = sites[i];
            if( site.post_id ) {
                return true;
            }
        }
        return false;
    }
    getState(outlet) {
        return outlet.activatedRouteData.state + this.slideshow.slideIndex;
    }
    toggle() {
        this.trayOpen = !this.trayOpen;
    }
    reset() {
        this.trayOpen = false;
        this.showPublishReadyBtn = false;
        this.slideshow.resetSlideshow();
        this.imagesService.reset();
        if( this.uploadSubscription ) {
            this.uploadSubscription.unsubscribe();
        }
    }
    delete() {
        this.assignments.delete([this.slideshow.assignment])
    }
    maybeAddComment() {
        const dialog = this.dialog.open(CommentDialog);
        dialog.afterClosed().subscribe(comment => {
            if( typeof comment === 'string' ) {
                this.slideshow.addComment(comment);
                this.slideshow.sendRevisionRequest();
            }
        });
    }
    ngOnDestroy() {
        if( this.deleteSubscription ) {
            this.deleteSubscription.unsubscribe();
        }
        if( this.slideshow.locked || this.slideshow.objEq(this.slideshow.getBackup(this.slideshow), this.slideshow.backup) ) {
            this.reset();
            return;
        }
        const dialog = this.dialog.open(GoBackDialog);
        dialog.afterClosed().subscribe(goBack => {
            if( goBack ) {
                this.slideshow.reload = true;
                this.router.navigate(['/slideshow', this.slideshow.assignment.id]);
            } else {
                this.reset();
            }
        });
    }
}
@Component({
    selector: 'go-back-dialog',
    template: `
        <h2 mat-dialog-title>Unsaved Changes</h2>
        <mat-dialog-content>
            <p>You have unsaved changes. Do you want to go back?</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button [mat-dialog-close]="false">Cancel</button>
            <button mat-button [mat-dialog-close]="true">Go Back</button>
        </mat-dialog-actions>`,
})
export class GoBackDialog {
    constructor() {}
}
@Component({
    selector: 'comment-dialog',
    template: `
        <h2 mat-dialog-title>Request Revision</h2>
        <mat-dialog-content id="revision-request">
            <div class="input-wrap"><textarea placeholder="Add a note" [(ngModel)]="comment" (keyup.enter)="send()"></textarea></div>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button mat-button [mat-dialog-close]="false">Cancel</button>
            <button mat-button [mat-dialog-close]="comment">Send</button>
        </mat-dialog-actions>`,
})
export class CommentDialog {
    comment = '';
    constructor(private ref: MatDialogRef<CommentDialog>) {}
    send() {
        this.ref.close(this.comment);
    }
}


// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/src/swarm/src/app/slideshow/slideshow.component.ts